<script>
  import Select from "svelte-select";
  import { i18n, changeLanguage } from "../../i18n";

  let items = [
    { value: "ru", label: "Русский", icon: "Ру" },
    { value: "en", label: "English", icon: "En" },
  ];

  function updateLanguage(e) {
    changeLanguage(e.detail.value);
  }

  $: selectedLang = items.find((x) => $i18n.language === x.value);
</script>

<!--
  `listAutoWidth` matches the list to the select, which is only as wide as the
  current language: "Русский" would be cut off in the list.
-->
<Select
  {items}
  value={selectedLang}
  clearable={false}
  searchable={false}
  listAutoWidth={false}
  filterSelectedItems={false}
  on:change={updateLanguage}
/>
